import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms"

export function loginOrEmailOrPhoneValidator() : ValidatorFn {
    return (control:AbstractControl<string>) : ValidationErrors | null => {
      const value = control.value
  
      if(!value || !value.length) {
        return { isEmpty : true }
      } else {
        // the string begins with + or only has digits
        const phonePattern = "^\\+?([0-9]+)$"
        if(value.match(phonePattern)){
          return null
        }
    
        // the string is an email
        const emailPattern = "^[a-zA-Z_\\-\\.0-9]+@[a-zA-Z_\\-0-9]+?\\.[a-zA-Z]{2,3}$"; 
        if(value.match(emailPattern)){
          return null
        }
  
        // the string is a login
        return null
      }
    }
  }